<template>
    <van-popup class="report-act-popup-box" position="bottom" v-bind:value="showCourseActPopup && showPopup" v-bind:close-on-click-overlay="false">
        <div class="report-act-popup-close" @click="clickClose"><span class="close"></span></div>
        <div class="report-act-popup course-act-popup" :class="userVip == 10 ? 'act-popup-1' : userVip == 20 ? 'act-popup-2' : userVip == 30 ? 'act-popup-3' : ''">
            <div class="report-act-pp-btn-box">
                <button class="report-act-pp-btn" @click="clickCourseActButton">前往课程中心享受特权</button>
            </div>
        </div>
    </van-popup>
</template>

<script>
import { CONFIG } from '../../modules/config'
export default {
    name: 'CourseActPopup',
    computed: {
        userVip() {
            return this.$store.state.userData && this.$store.state.userData.info ? this.$store.state.userData.info.vip : 0;
        },
        showCourseActPopup() {
            return this.$store.state.course.showCourseActPopup;
        }
    },
    data() {
        return {
            showPopup: true
        }
    },
    mounted() {
        let path = this.$router.history.current.fullPath;
        if(path.indexOf('diagram') != -1 || path.indexOf('strong') != -1) {
            this.showPopup = false
        }
    },
    methods: {
        clickClose() {
            this.$store.state.course.showCourseActPopup = false;
            let newParams = {};
            switch(this.userVip) {
                case 10:
                    newParams = {'course_privilege_h5_month' : 1};
                    break;
                case 20:
                    newParams = {'course_privilege_h5_year' : 1};
                    break;
                case 30:
                    newParams = {'course_privilege_h5_forever' : 1};
                    break;
                default:
                    break;
            }
            this.$store.dispatch('reminder/udpateExtList', {
                params: newParams
            });
        },
        clickCourseActButton() {
            this.clickClose();
            let curPath = this.$router.history.current.path;
            if(curPath.indexOf('my') >= 0) {
                this.$router.replace('/courselist/my');
            }else {
                this.$router.replace('/courselist/collate');
            }
        },
    }
}
</script>
